export const getters = {
    getCongregacoes: (state) => state.congregacoes,
};